import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TableColComponent } from './table-col.component';
import { TableComponent } from './table.component';

@Component({
  selector: 'mtg-table-identity-col',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableIdentityColComponent extends TableColComponent {
  @HostBinding('class.identity')
  identityClass = true;
  constructor(
    private tableComponent: TableComponent
  ) {
    super();
    this.tableComponent.hasIdentityCol = true;
  }
}
